import { getResource } from "../api/http";

// Most active users over a period ("users" section): active days and
// actions (videos, comments, Merci, likes, watchlist, donations).
const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** `{ days, sort, page, q }` → `{ items, total, page, pageSize, totals, period, since, weights }`. */
export const getActiveUsers = (params) => getResource(`/api/admin/active-users${query(params)}`, { fallback: null });
